import { render, staticRenderFns } from "./KanbanSettings.vue?vue&type=template&id=18c342a2&scoped=true"
import script from "./KanbanSettings.vue?vue&type=script&lang=js"
export * from "./KanbanSettings.vue?vue&type=script&lang=js"
import style0 from "./KanbanSettings.vue?vue&type=style&index=0&id=18c342a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c342a2",
  null
  
)

export default component.exports